module.exports = __webpack_public_path__ + "assets/pictograms/registration_illustration.dd99ea3691d870fc4d8f4427b0182a4c.svg";